import React, { useState } from "react";

//Feather icons
import {
  X,
  Mic,
  Send,
  Smile,
  Paperclip
} from "react-feather";

//Emoji picker
import Picker from "emoji-picker-react";

//API
import api from "../services/api";

//Auth
import { useAuth } from "../providers/auth";

const pickerStyle = { width: "100%", height: "300px", borderRadius: "0px" };

const InputOptions = ({ selectedChats }) => {

  console.log(selectedChats);

  const { user } = useAuth();

  const [emojiToggle, setEmojiToggle] = useState(false);
  const isActiveEmoji = emojiToggle ? "active-toggle" : "inactive-toggle";

  const [message, setMessage] = useState("");

  const onEmojiClick = (e, emojiObject) => setMessage(message+emojiObject.emoji);

  const sendMessageToMultipleCustomers = () => {

    if(message !== "") {
      const config = { headers: { "Authorization": "Bearer " + user.token } }
      const data = { chats_id: selectedChats.chats, type: "text", body: message };

      try {
        const response = api.post(`/messages/send/selection`, data, config);

        setEmojiToggle(false);
        console.log(response.data);
      } catch (err) {
        console.log(err);
      }
    }
  }

  return (
    <div>
      <div className={isActiveEmoji}>
        <Picker onEmojiClick={onEmojiClick} pickerStyle={pickerStyle}/>
      </div>

      <form className="actions">
        <div className="inner-actions">
          <div className="actions-above">
            <textarea
              value={message}
              rows="3"
              placeholder="Escreva a mensagem..."
              onChange={e => setMessage(e.target.value)}
              className="message-input-sender"
            />
          </div>

          <div className="actions-below mt-10 pb-20">

            <button type="button" className="action-btn mr-20" onClick={() => setEmojiToggle(!emojiToggle)}>
              {emojiToggle ? <X/> : <Smile />}
            </button>

            <label className="action-btn mr-20">
              <Paperclip />
              <input hidden type="file" multiple accept="audio/*, video/*, image/*, .zip, .rar" />
            </label>

            <button type="button" className="action-btn mr-20">
              <Mic />
            </button>

            <button type="button" className="action-btn" onClick={sendMessageToMultipleCustomers}>
              <Send />
            </button>

          </div>
        </div>
      </form>
    </div>
  )
}

export default InputOptions;